import { Injectable } from '@angular/core';

@Injectable()
export class GoogleMapsService {

    private loadAPI: Promise<any>;

    constructor() {
    }

    public loadScript() {
        const dynamicScripts = [
            'https://maps.googleapis.com/maps/api/js?callback=__onGoogleLoaded'
                + '&key=AIzaSyAOE35O6tjzlhV-nZRgwJOdZND8Wv3Cm7A&libraries=geometry,visualization'
        ];

        for (const script of dynamicScripts) {
            const node = document.createElement('script');
            node.src = script;
            node.type = 'text/javascript';
            node.async = true;
            node.defer = true;
            document.getElementsByTagName('head')[0].appendChild(node);
        }
    }

    isApiLoaded(): boolean {
        return (window as any).google ? true : false;
    }

    loadApi() {
        this.loadScript();
        return this.loadAPI = new Promise((resolve) => {
            (window as any).__onGoogleLoaded = _ => {
                resolve(true);
            };
        });
    }
}
